import { createContext, ReactNode, use } from "react";

const VideoSuspensionContext = createContext(false);

/** Whether the tiles below this point should release their media buffers. */
export const useVideoSuspended = (): boolean => use(VideoSuspensionContext);

export const VideoSuspensionProvider = ({
  suspended,
  children,
}: {
  suspended: boolean;
  children: ReactNode;
}) => (
  <VideoSuspensionContext value={suspended}>{children}</VideoSuspensionContext>
);
